import React from 'react'
import { type GrowProps, Grow } from '@mui/material'

export const GrowTransition = React.forwardRef<HTMLDivElement, GrowProps>(
  function GrowTransition(props, ref) {
    return <Grow ref={ref} {...props} />
  }
)
